import { createFileRoute } from '@tanstack/react-router';
import { AllTasksScreen } from '../../screens/AllTasks';

export const Route = createFileRoute('/tasks/all')({
  component: AllTasksScreen,
});
